// @flow

import React, { PureComponent } from 'react'
import styles from './App.css'
import { Cards } from './cards/index'
import type { Doc } from './domain/index'
import { Stories } from './stories/index'

type AppProps = {
  document: Doc,
  cards: boolean,
  range: string
}

export class App extends PureComponent<AppProps> {
  render () {
    const {range, cards, document} = this.props
    const all = !range && !cards

    return (
      <div className={styles.app}>
        {(all || !!cards) && (
          <Cards kort={document.kort} />
        )}

        {(all || !!range) && (
          <Stories historier={document.historier} range={range || '0-100'} />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/App.js